<script lang="ts">
	// Design system components
	import { Select } from '@Shelly/shelly-design-system';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	// Config
	import { getTempSchemeChartConfig } from 'src/helpers/statistics/config/temp_scheme';
	import { getDailyRangeOptions, startsWeekOnSun } from 'src/helpers/date_helper';
	// Components
	import LayerChartRenderer from '../LayerChart/LayerChartRenderer.svelte';
	//Types
	import type { ChartDataInterface } from 'src/types/Chart';
	import type { IChartTempSchedule } from 'src/types/TemperatureSchemeType';
	import { format } from 'svelte-i18n';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let data: IChartTempSchedule;
	export let editMode: boolean = false;
	export let forceEnabled: boolean = false;

	const startWeekOnSun = startsWeekOnSun(),
		rangeOptions = getDailyRangeOptions(startWeekOnSun),
		onChangeRange = (range: number) => {
			rangeValue = rangeOptions.find((el) => el.value === range);
			chartData = getTempSchemeChartConfig(range, data, startWeekOnSun);
		},
		selectChangeRange = (e: CustomEvent | { detail: number }) => {
			onChangeRange(e.detail.value);
		};

	let rangeValue = rangeOptions[0],
		chartData: ChartDataInterface;

	$: chartData = getTempSchemeChartConfig(rangeValue.value, data, startWeekOnSun);
</script>

<div class="d-flex">
	<Select
		id="select-temp-scheme-chart-range"
		aria-label={$format('select_temp_scheme_chart_range', {
			default: 'Select temperature scheme chart range',
		})}
		class={classMap({ 'mb-m': $showNewLayout })}
		disabled={editMode}
		value={rangeValue}
		size="m"
		icon="fas fa-clock-rotate-left"
		options={rangeOptions}
		on:change={selectChangeRange}
		on:click={(e) => {
			e.preventDefault();
			e.stopPropagation();
			return;
		}}
	/>
</div>
<div class:pointer-events-none={editMode}>
	<LayerChartRenderer chartData={forceEnabled ? { ...chartData, disabled: false } : chartData} />
</div>
